import { createFileRoute } from '@tanstack/react-router';
import { AcubeJobDetailRoute } from '@/pages/acube-jobs/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/admin/_layout/acube-jobs/_layout/$id')({
  component: AcubeJobDetailRouteComponent,
});

function AcubeJobDetailRouteComponent() {
  const { id } = Route.useParams();

  return <AcubeJobDetailRoute jobId={id} />;
}
